exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addInvestmentCard .v--modal-box.v--modal{min-height:360px!important;min-width:600px!important}#addInvestmentCard .v-tabs__div:not(:last-child){padding-right:5px}#addInvestmentCard .v-select__selection{font-size:12px!important}#addInvestmentCard .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#addInvestmentCard .v-tabs__wrapper--show-arrows{margin-left:0;margin-right:0}#addInvestmentCard .caption--long{display:block;max-width:140px}.btnDisabled{pointer-events:none!important;color:#888!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7846d746","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/management/modals/AddInvestmentCard.vue
// module id = 2237
// module chunks = 0